module.exports = __webpack_public_path__ + "static/media/under16-gift-banner-desktop.d32a5317.jpg";